import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { fetchInventoryAnomalies } from "../../../api/inventory";
import { RouterNavLink } from "../../../components/RouterNavLink";
import { useAsyncData } from "../../../hooks/useAsyncData";

export function DashboardAnomaliesBanner() {
  const { t } = useTranslation();
  const { data: flags, isLoading, error } = useAsyncData(
    useCallback(() => fetchInventoryAnomalies(), []),
  );

  const openCount = flags?.length ?? 0;

  return (
    <section
      className="rounded-xl border border-amber-200 bg-amber-50/70 p-3"
      aria-label={t("dashboard.anomalies_banner_title")}
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-start gap-2">
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" aria-hidden />
          <div>
            <h2 className="text-sm font-bold text-amber-950">
              {t("dashboard.anomalies_banner_title")}
            </h2>
            <p className="mt-0.5 text-xs text-amber-900/80">
              {isLoading
                ? t("labels.loading")
                : error
                  ? t("dashboard.anomalies_load_failed")
                  : openCount === 0
                    ? t("dashboard.anomalies_none_open")
                    : t("dashboard.anomalies_open_count", { count: openCount })}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <RouterNavLink
            to="/inventory/anomalies"
            className="rounded-lg bg-amber-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-800"
          >
            {t("dashboard.anomalies_review")}
          </RouterNavLink>
          <RouterNavLink
            to="/ai-advisor"
            className="rounded-lg border border-amber-300 bg-white px-3 py-1.5 text-xs font-semibold text-amber-900 hover:bg-amber-100/80"
          >
            {t("dashboard.anomalies_ask_ai")}
          </RouterNavLink>
        </div>
      </div>
    </section>
  );
}
